import { CountryFlag } from '@/common/base/country-flag';
import { CompanyLogo } from '../../components/company-logo';
import type { PlatformCompany } from '../../../../types';

interface HeaderBlockProps {
  company: Pick<PlatformCompany, 'companyName' | 'logoUrl' | 'countryCode'>;
}

export function HeaderBlock({ company }: HeaderBlockProps) {
  const { companyName, logoUrl, countryCode } = company;
  const resolvedLogoUrl = logoUrl?.startsWith('//') ? `https:${logoUrl}` : (logoUrl ?? undefined);

  return (
    <div className="flex items-center gap-2 min-w-0">
      <CompanyLogo imageUrl={resolvedLogoUrl} className="shrink-0" />
      <span className="text-sm font-medium text-[#262626] truncate flex-1 min-w-0" title={companyName ?? '—'}>
        {companyName ?? '—'}
      </span>
      {countryCode && <CountryFlag countryCode={countryCode} size={16} className="shrink-0" />}
    </div>
  );
}
